import { Box, Button, Modal, Spinner, Text } from '@ksyos/design-system';
import { translateKey } from '../../../translate';

export interface IConfirmationModalProps {
    cancelText?: string;
    confirmText?: string;
    disabled?: boolean;
    handleNo: () => void;
    handleYes: () => void;
    hideConfirmButton?: boolean;
    isLoading?: boolean;
    isOpen: boolean;
    question: string | JSX.Element;
    title: string;
}

export function ConfirmationModal(props: IConfirmationModalProps) {
    return (
        <Modal
            isOpen={props.isOpen}
            onClose={props.handleNo}
            size="medium"
        >
            {props.title && <Modal.Header>{props.title}</Modal.Header>}
            <Modal.CloseButton />
            <Modal.Body>
                <Text>{props.question}</Text>
            </Modal.Body>
            <Modal.Footer>
                <>
                    <Button
                        isDisabled={props.disabled}
                        onClick={props.handleNo}
                        type="button"
                        variant="outline"
                    >
                        {props.cancelText || translateKey('common.no')}
                    </Button>

                    {!props.hideConfirmButton && (
                        <Button
                            isDisabled={props.disabled || props.isLoading}
                            onClick={props.handleYes}
                            type="button"
                            variant="solid"
                        >
                            <Box
                                alignItems="center"
                                display="flex"
                            >
                                {props.isLoading && <Spinner style={{ marginRight: 'var(--kds-spacing-2)' }} />}
                                {props.confirmText || translateKey('common.yes')}
                            </Box>
                        </Button>
                    )}
                </>
            </Modal.Footer>
        </Modal>
    );
}
